export default vm => {
    return vm.profile.customerId
        ? vm.$cbrDataProvider
            .get('profile')
            .then(({ permissions }) => permissions)
            .catch(() => [])
        : Promise.resolve([]);
};
